<div class="bank-details-container" [formGroup]="formGroup">

  <!-- Branch Information Card -->
  <div class="section-card">
    <p class="note">For Direct Crediting of commission into the following Bank Account
      (POSB/DBS accounts preferred)
    </p>
    <div class="container-fluid">

      <div class="row g-3">

        <!-- Branch Name -->
        <div class="col-md-6">
          <mat-label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            Bank Name
          </mat-label>

          <mat-form-field class="w-100">
            <mat-select formControlName="bankName" placeholder="Select Bank Name" required>
              @for(bankname of this.banknames; track bankname) {
              <mat-option value="{{bankname.value}}">{{bankname.name}}</mat-option>
              }
            </mat-select>
            @if(this.formGroup.controls["bankName"].invalid
            && (this.formGroup.controls["bankName"].touched ||
            this.formGroup.controls["bankName"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["bankName"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Financial Services Director -->
        <div class="col-md-6">
          <mat-label class="field-label">
            <!-- <mat-icon class="label-icon">star</mat-icon> -->
            Branch Name
          </mat-label>

          <mat-form-field class="w-100">
            <input matInput formControlName="branchname" placeholder="Enter Branch Name" required>
            @if(this.formGroup.controls["branchname"].invalid
            && (this.formGroup.controls["branchname"].touched ||
            this.formGroup.controls["branchname"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["branchname"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Financial Services Manager -->
        <div class="col-md-6">
          <mat-label class="field-label">
            <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
            Account Number
          </mat-label>

          <mat-form-field class="w-100">
            <input matInput type="text" formControlName="accountNumber" placeholder="Enter Account Number" required>
            @if(this.formGroup.controls["accountNumber"].invalid
            && (this.formGroup.controls["accountNumber"].touched ||
            this.formGroup.controls["accountNumber"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["accountNumber"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-label class="field-label">Attachment (Bank account details)</mat-label>
          <div class="upload-container">
            <div class="upload-box">
              <input type="file" id="attachmentbankaccoutndetailsfileName" accept=".pdf,.jpg,.jpeg,.png"
                [disabled]="readonly()" (change)="onAttachmentbankaccoutndetailsFileChange($event)">
              <input type="text" formControlName="attachmentbankaccoutndetailsfileName" hidden>

              <!-- Show filename OR placeholder -->
              @if(!this.formGroup.get('attachmentbankaccoutndetailsfileName')?.value){
              <span>
                Choose a file
              </span>
              }
              @if(this.formGroup.get('attachmentbankaccoutndetailsfileName')?.value){
              <div class="attachment-row">
                <span class="file-name">
                  {{ this.formGroup.get('attachmentbankaccoutndetailsfileName')?.value }}
                </span>
                @if(readonly() === false){
                <button mat-icon-button color="primary" class="delete-btn"
                  (click)="removeFile('attachmentbankaccoutndetailsfileName','attachmentbankaccoutndetails','Attachement(Bank Account)')">
                  <mat-icon>close</mat-icon>
                </button>
                }
                <button mat-icon-button color="primary" class="delete-btn"
                (click)="previewAttachment('attachmentbankaccoutndetailsfileName','Attachement(Bank Account)')">
                <mat-icon>visibility</mat-icon>
                </button>
              </div>
              }
            </div>
          </div>
          @if(this.formGroup.controls["attachmentbankaccoutndetailsfileName"].invalid
          && (this.formGroup.controls["attachmentbankaccoutndetailsfileName"].touched ||
          this.formGroup.controls["attachmentbankaccoutndetailsfileName"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["attachmentbankaccoutndetailsfileName"].errors?.["required"]) {
            <span>{{message}}</span>
            }@else if(this.formGroup.controls["attachmentbankaccoutndetailsfileName"].errors?.['invalidType']){
            <span>Only PDF, JPG, PNG files are allowed.</span>
            }
            @else if(this.formGroup.controls["attachmentbankaccoutndetailsfileName"].errors?.['maxSize']){
            <span>File size must be less than or equal to 5MB.</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </div>

      </div>

    </div>

  </div>

</div>
@if(readonly() === false){
<!-- Form Actions -->
<div class="form-actions">

  <button mat-raised-button class="save-btn" (click)="saveAndContinue()">

    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>

  </button>

</div>
}